"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TreeSelectComponent = TreeSelectComponent;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _DropdownTreeSelectMemoized = require("./DropdownTreeSelectMemoized");

var _treeSelectUtils = require("../utilities/treeSelectUtils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var selectAllValue = 'all'; // eslint-disable-next-line complexity

function getClassName(isFocused, isValid, hidePills) {
  var className = 'tree-select';

  if (!isValid) {
    className += ' tree-select--error';
  }

  if (isFocused) {
    className += ' tree-select--focused';
  }

  if (hidePills) {
    className += ' tree-select--hide-pills';
  }

  return className;
} // eslint-disable-next-line complexity


function getInitialTreeInfo(props) {
  var _options$map;

  var expandedNodes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var hasSelectAllOption = props.hasSelectAllOption,
      options = props.options,
      placeholder = props.placeholder,
      selectAllLabel = props.selectAllLabel,
      textField = props.textField,
      valueField = props.valueField,
      value = props.value;
  var texts = {
    placeholder: placeholder || ''
  };
  var topLevelOptions = (_options$map = options === null || options === void 0 ? void 0 : options.map(function (option) {
    var _ref;

    return _ref = {}, _defineProperty(_ref, textField, option[textField]), _defineProperty(_ref, valueField, option[valueField]), _ref;
  })) !== null && _options$map !== void 0 ? _options$map : [];
  var selectAllOption = {
    label: selectAllLabel,
    value: selectAllValue,
    className: 'select-all',
    expanded: true
  };
  var mappedOptions = (0, _treeSelectUtils.sanitizeOptions)(options, textField, valueField, value, expandedNodes);
  var optionsList = hasSelectAllOption && mappedOptions !== null && mappedOptions !== void 0 && mappedOptions.length ? [_objectSpread(_objectSpread({}, selectAllOption), {}, {
    children: mappedOptions
  })] : mappedOptions;
  return {
    texts: texts,
    topLevelOptions: topLevelOptions,
    optionsList: optionsList
  };
}

function applyNoOptionsClass(containerRef, noOptionsMessage) {
  setTimeout(function () {
    var _containerRef$current;

    var content = (_containerRef$current = containerRef.current) === null || _containerRef$current === void 0 ? void 0 : _containerRef$current.querySelector('.dropdown-content');
    var items = content === null || content === void 0 ? void 0 : content.querySelectorAll('ul li');

    if (content && !(items !== null && items !== void 0 && items.length)) {
      content.classList.add('dropdown-content--no-options');
      content.innerHTML = noOptionsMessage;
    }
  }, 0);
} // eslint-disable-next-line max-params, complexity


function setPlaceholderText(containerRef, numberOfSelectedItems, placeholderText, arePillsHidden) {
  var _containerRef$current2;

  var input = (_containerRef$current2 = containerRef.current) === null || _containerRef$current2 === void 0 ? void 0 : _containerRef$current2.querySelector('li.tag-item > input');

  if (arePillsHidden && numberOfSelectedItems > 0) {
    input.placeholder = "".concat(numberOfSelectedItems, " item(s) selected");
  } else {
    input.placeholder = numberOfSelectedItems > 0 ? '' : placeholderText;
  }
}

function TreeSelectComponent(props) {
  var _treeInfo$optionsList;

  var containerRef = (0, _react.useRef)();

  var _useState = (0, _react.useState)(getInitialTreeInfo(props)),
      _useState2 = _slicedToArray(_useState, 2),
      treeInfo = _useState2[0],
      setTreeInfo = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      focused = _useState4[0],
      setFocused = _useState4[1];

  var _useState5 = (0, _react.useState)([]),
      _useState6 = _slicedToArray(_useState5, 2),
      expandedNodes = _useState6[0],
      setExpandedNodes = _useState6[1];

  var onBlur = (0, _react.useCallback)(function () {
    return setFocused(false);
  }, []);
  var onFocus = (0, _react.useCallback)(function () {
    setFocused(true);
    applyNoOptionsClass(containerRef, props.noOptionsMessage);
  }, [props.noOptionsMessage]);
  var onNodeToggle = (0, _react.useCallback)(function (node) {
    if (node.value === selectAllValue) {
      setExpandedNodes([]);
    } else {
      setExpandedNodes(function (prevState) {
        return node.expanded ? [].concat(_toConsumableArray(prevState), [node]) : prevState.filter(function (x) {
          return x.value !== node.value;
        });
      });
    }
  }, []);
  /* eslint-disable react-hooks/exhaustive-deps, indent */

  var handleChange = (0, _react.useCallback)(function (selectedItem, selectedNodes) {
    var _selectedNodes$;

    var selectedOptions = (selectedNodes === null || selectedNodes === void 0 ? void 0 : (_selectedNodes$ = selectedNodes[0]) === null || _selectedNodes$ === void 0 ? void 0 : _selectedNodes$.value) === selectAllValue ? treeInfo.topLevelOptions : (0, _treeSelectUtils.mapSelectedToTextFieldValueField)(selectedNodes, props.textField, props.valueField);
    props.onChange(selectedOptions);
  }, [treeInfo, props.onChange]);
  (0, _react.useEffect)(function () {
    var _props$value$length, _props$value;

    var newTreeInfo = getInitialTreeInfo(props, expandedNodes);
    setTreeInfo(newTreeInfo);
    setPlaceholderText(containerRef, (_props$value$length = (_props$value = props.value) === null || _props$value === void 0 ? void 0 : _props$value.length) !== null && _props$value$length !== void 0 ? _props$value$length : 0, newTreeInfo.texts.placeholder, props.hidePills);
  }, [expandedNodes, props.hidePills, props.options, props.value, treeInfo.texts.placeholder]);
  /* eslint-enable react-hooks/exhaustive-deps, indent */

  return /*#__PURE__*/_react["default"].createElement("div", {
    ref: containerRef,
    className: getClassName(focused, props.isValid, props.hidePills)
  }, /*#__PURE__*/_react["default"].createElement(_DropdownTreeSelectMemoized.DropdownTreeSelectMemoized, {
    clearSearchOnChange: props.clearSearchOnChange,
    data: treeInfo.optionsList,
    disabled: !((_treeInfo$optionsList = treeInfo.optionsList) !== null && _treeInfo$optionsList !== void 0 && _treeInfo$optionsList.length) || props.disabled,
    hasSelectAllOption: props.hasSelectAllOption,
    keepChildrenOnSearch: props.keepChildrenOnSearch,
    keepTreeOnSearch: props.keepTreeOnSearch,
    onChange: handleChange,
    onFocus: onFocus,
    onBlur: onBlur,
    onNodeToggle: onNodeToggle,
    showPartiallySelected: props.showPartiallySelected,
    texts: treeInfo.texts,
    readOnly: props.readOnly
  }));
}
/* eslint-disable react/no-unused-prop-types */


TreeSelectComponent.propTypes = {
  clearSearchOnChange: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  readOnly: _propTypes["default"].bool,
  hasSelectAllOption: _propTypes["default"].bool,
  hidePills: _propTypes["default"].bool,
  isValid: _propTypes["default"].bool.isRequired,
  keepChildrenOnSearch: _propTypes["default"].bool,
  keepTreeOnSearch: _propTypes["default"].bool,
  noOptionsMessage: _propTypes["default"].string,
  onChange: _propTypes["default"].func.isRequired,
  options: _propTypes["default"].instanceOf(Array),
  placeholder: _propTypes["default"].string,
  selectAllLabel: _propTypes["default"].string,
  showPartiallySelected: _propTypes["default"].bool,
  textField: _propTypes["default"].string.isRequired,
  valueField: _propTypes["default"].string.isRequired,
  value: _propTypes["default"].instanceOf(Array)
};
TreeSelectComponent.defaultProps = {
  clearSearchOnChange: true,
  disabled: false,
  hasSelectAllOption: true,
  hidePills: false,
  keepChildrenOnSearch: true,
  keepTreeOnSearch: true,
  noOptionsMessage: 'No options',
  placeholder: '',
  readOnly: false,
  selectAllLabel: 'All',
  showPartiallySelected: true,
  value: []
};